/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.25",
    versionName: "0.2.0-nightly.2025.9.25",
    versionChannel: "nightly",
    buildDate: "2025-09-25T00:09:40.061Z",
    commitHash: "e522fcfb1fc043356dbbc0ce23fa38d4d5c8335e",
};
